export default "__VITE_ASSET__BKlwZEEF__"